import React, {useEffect, useState} from "react";
import {useLocation, useHistory} from "react-router-dom";
import {Grid} from "@mui/material";

import DropdownMenu from "../../components/DropdownMenu";
import {Header} from "../../components/structure/Header";
import {SEText} from "../../components/SEText";
import {ReportsFilterProvider} from "../../../context/ReportsFilterContext";

import {Acessos} from "./Acessos";
import {AtendimentosSala} from "./AtendimentosSala";
import {AtendimentosSse} from "./AtendimentosSse";
import {AtendimentosSebrae} from "./AtendimentosSebrae";
import {AtendimentosAgenteSseCredito} from "./AtendimentosAgenteSseCredito";

export const REPORT_TYPE_TAB = Object.freeze({
    PANEL: 0,
    REPORT: 1,
});

type MenuOption = {
    id: string;
    label: string;
    component?: JSX.Element;
};

const menuOptions: MenuOption[] = [
    {id: "acessos", label: "Acessos", component: <Acessos/>},
    // { id: "agendamentos", label: "Agendamentos" },
    {id: "atendimentos-sse", label: "Atendimentos SSE", component: <AtendimentosSse/>},
    {id: "atendimentos-sala", label: "Atendimentos Sala", component: <AtendimentosSala/>},
    {id: "atendimentos-sebrae", label: "Atendimentos Sebrae", component: <AtendimentosSebrae/>},
    {id: "atendimentos-agente-sse-credito", label: "Agente SSE Crédito", component: <AtendimentosAgenteSseCredito/>},
    // { id: "diagnosticos", label: "Diagnósticos Realizados" },
    // { id: "registros-sas", label: "Registros (SAS)" },
    // { id: "usuarios", label: "Usuários" },
    // { id: "notificacoes", label: "Notificações" },
    // { id: "perfil-do-usuario", label: "Perfil do usuário" },
];

const Reports = () => {
    const history = useHistory();
    const location = useLocation();

    const currentReportId = location.pathname.split("/")[2];
    const defaultOption = menuOptions.find((opt) => opt.id === currentReportId) || menuOptions[0];

    const [selectedOption, setSelectedOption] = useState<MenuOption>(defaultOption);

    const handleChangeMenu = (option: MenuOption) => {
        setSelectedOption(option);
        history.push(`/reports/${option.id}`);
    };

    useEffect(() => {
        const newReportId = location.pathname.split("/")[2];
        const matchingOption = menuOptions.find((opt) => opt.id === newReportId);

        if (matchingOption && matchingOption.id !== selectedOption.id) {
            setSelectedOption(matchingOption);
        }
    }, [location.pathname, selectedOption]);

    useEffect(() => {
        const isRootReports = location.pathname === "/reports" || location.pathname === "/reports/";
        if (isRootReports) {
            history.replace(`/reports/${menuOptions[0].id}`);
        }
    }, [location.pathname, history]);

    return (
        <ReportsFilterProvider>
            <Header>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item sx={{flexGrow: 1}}>
                        <SEText type="title">Relatórios</SEText>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            flexGrow: 2,
                            pr: 3,
                            pt: 2,
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <DropdownMenu
                            options={menuOptions}
                            selectedOption={selectedOption.id}
                            onSelect={handleChangeMenu}
                        />
                    </Grid>
                </Grid>
            </Header>

            <Grid container>
                <Grid item xs={12}>
                    {selectedOption.component}
                </Grid>
            </Grid>
        </ReportsFilterProvider>
    );
};

export default Reports;
